import { render, staticRenderFns } from "./MarketReports.vue?vue&type=template&id=38b0448c&scoped=true&"
import script from "./MarketReports.vue?vue&type=script&lang=js&"
export * from "./MarketReports.vue?vue&type=script&lang=js&"
import style0 from "./MarketReports.vue?vue&type=style&index=0&id=38b0448c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b0448c",
  null
  
)

export default component.exports